import React from 'react';
import { TouchableOpacity } from 'react-native';
import {
  ScrollUpContainer,
  ScrollUpIcon,
  ScrollUpText,
} from '../styles/styledComponents/editProfileForm';
import { green, sand } from '../styles/colors';

interface BackToTopButtonProps {
  scrollToTop: () => void;
  alternateStyle?: boolean;
}

const BackToTopButton: React.FC<BackToTopButtonProps> = ({
  scrollToTop,
  alternateStyle = false,
}) => {
  return (
    <ScrollUpContainer>
      <TouchableOpacity onPress={scrollToTop} style={{ paddingRight: 2 }}>
        <ScrollUpIcon
          source={
            alternateStyle
              ? require('@/assets/images/ScrollUpIconAlternate.png')
              : require('@/assets/images/ScrollUpIcon.png')
          }
        />
      </TouchableOpacity>
      <ScrollUpText style={{ color: alternateStyle ? sand : green }}>
        BACK TO TOP
      </ScrollUpText>
    </ScrollUpContainer>
  );
};

export default BackToTopButton;
